<template>
    <div class="tongyong">
        <div class="tongyong_top">
            <p>{{title}}</p>
            <div></div>
        </div>
        <ul class="lawcommontw">
            <li v-for="(item,index) in content" :key="index">
                <div class="lawtwlifr">
                    <p></p>
                    <p>0{{index+1}}</p>
                </div>
                <div :class="content.length-1==index?'lawtwlise lawtwlisela':'lawtwlise'">
<!--                    <p>STEP {{item.english}}</p>-->
                    <p>{{item.content}}</p>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name:'lawcommontw',
        props:{
            content:{
                type: Array,
                default:()=>[]
            },
            title:{
                type: String,
                default:''
            }
        },
        data(){
            return {

            }
        },
        methods:{

        },
        mounted(){

        },
        created(){

        }
    }
</script>

<style scoped lang="less">
    .tongyong{
        width:603px;
        height:526px;
        background:rgba(255,255,255,1);
        box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
    }
    .tongyong_top{
        margin-left:49px;
        margin-top:30px;
        p{
            height:36px;
            font-size:25px;
            font-weight:400;
            color:rgba(4,4,4,1);
            line-height:36px;
            letter-spacing:3px;
        }
        div{
            width:193px;
            height:25px;
            background:rgba(216,216,216,1);
            opacity:0.15;
            margin-top:-20px;
            margin-bottom:38px;
        }
    }
    .lawcommontw{
        li{
            list-style:none;
            .lawtwlifr{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                p:first-child{
                    width:10px;
                    height:10px;
                    background:rgba(216,216,216,1);
                    margin-left:54px;
                    border-radius:50%;
                }
                p:last-child{
                    margin-left:40px;
                    height:25px;
                    font-size:18px;
                    font-weight:bold;
                    color:rgba(51,51,51,1);
                    line-height:25px;
                }
            }
            .lawtwlise{
                margin-left: 58px;
                padding-left: 44px;
                border-left: 2px dashed rgba(216,216,216,1);
                height: 80px;
                p:first-child{
                    height:17px;
                    font-size:12px;
                    font-family:PingFangSC-Regular,PingFang SC;
                    font-weight:400;
                    color:rgba(153,153,153,1);
                    line-height:17px;
                    position:absolute;
                    margin-top: -17px;
                    background: #fff;
                }
                p:last-child{
                    height:25px;
                    font-size:18px;
                    font-weight:400;
                    color:rgba(51,51,51,1);
                    line-height:25px;
                    margin-top:5px;
                    padding-top: 5px;
                }
            }
            .lawtwlisela{
                border:none;
            }
        }
    }
</style>